import React from 'react';
import { IRiskTolerance } from '../../../../../sp-types/accountTypes';
import { FormatToShortPriceTemplate } from '../../../../../utils/FormatValue';

export interface GaugeBarTicks {
  riskToleranceValues: IRiskTolerance;
  numberOfTicks: number;
  tickerHight: number;
  zeroPositionAsPrec: string;
  calculations: {
    dangerLeftArea: string;
    possibleLeftArea: string;
    optimalArea: string;
    possibleRightArea: string;
    dangerRightArea: string;
  };
}

export const GaugeBarAreaTicks: React.FC<GaugeBarTicks> = ({
  calculations,
  tickerHight,
  riskToleranceValues: riskToleranceValues,
}) => {
  return !calculations || !riskToleranceValues ? (
    <></>
  ) : (
    <div className={`w-full  mt-[0rem]   flex`} style={{ minHeight: `${tickerHight}rem` }}>
      <GaugeBarAreaTickWithNumber
        divWidth={calculations.dangerLeftArea}
        value={riskToleranceValues.dangerAreaMinus.start}
      />
      <GaugeBarAreaTickWithNumber
        divWidth={calculations.possibleLeftArea}
        value={riskToleranceValues.dangerAreaMinus.end}
      />
      <GaugeBarAreaTickWithNumber
        wNumber={false}
        divWidth={calculations.optimalArea}
        value={riskToleranceValues.stableArea.start}
      />
      <GaugeBarAreaTickWithNumber
        divWidth={calculations.possibleRightArea}
        value={riskToleranceValues.stableArea.end}
        wNumber={false}
      />
      <GaugeBarAreaTickWithNumber
        divWidth={calculations.dangerRightArea}
        value={riskToleranceValues.dangerAreaPlus.start}
      />
      <GaugeBarAreaTickWithNumber divWidth={'0.2'} value={riskToleranceValues.dangerAreaPlus.end} tickerHight={0.75} />
    </div>
  );
};

interface GaugeSmallAreaProps {
  divWidth: string;
  value: number;
  wNumber?: boolean;
  toShortString?: boolean;
  tickerHight?: number;
}

const GaugeBarAreaTickWithNumber: React.FC<GaugeSmallAreaProps> = ({
  divWidth,
  value,
  toShortString = true,
  tickerHight = 0.75,
  wNumber = true,
}) => {
  const formattedValue = toShortString ? FormatToShortPriceTemplate(value, '', 0) : value.toLocaleString();

  return (
    <div style={{ width: `${divWidth}%` }} className={`  `}>
      <div className={`border-l border-l-secondary h-[${tickerHight}rem]`}></div>
      <div style={{ marginLeft: -getStringWidth(formattedValue, 10) / 2 + 'px' }} className={`  text-xs hover:z-50 `}>
        {wNumber ? formattedValue : ''}
      </div>
    </div>
  );
};

function getStringWidth(text: string, fontSize: number): number {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = `${fontSize}px Inter`;
    const textWidth = context.measureText(text).width;
    return textWidth;
  }

  return 0;
}
